import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { providers } from 'ethers';
import { Event } from '../../../../helpers/event';
export var InjectedConnector = /*#__PURE__*/function () {
  function InjectedConnector(provider) {
    _classCallCheck(this, InjectedConnector);
    this.name = 'Injected';
    this.update = new Event();
    this.provider = providers.Provider.isProvider(provider) ? provider : new providers.Web3Provider(provider);
  }
  _createClass(InjectedConnector, [{
    key: "connectEagerly",
    value: function () {
      var _connectEagerly = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var chainId, accounts;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.provider) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.prev = 2;
              _context.next = 5;
              return this.provider.send('eth_chainId', []);
            case 5:
              chainId = _context.sent;
              _context.next = 8;
              return this.provider.send('eth_accounts', []);
            case 8:
              accounts = _context.sent;
              this.update.emit({
                chainId: parseInt(chainId),
                accounts: accounts
              });
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              console.debug(_context.t0);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 12]]);
      }));
      function connectEagerly() {
        return _connectEagerly.apply(this, arguments);
      }
      return connectEagerly;
    }()
  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var chainId, accounts;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.provider) {
                _context2.next = 2;
                break;
              }
              throw new Error('Could not activate connector');
            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return this.provider.send('eth_chainId', []);
            case 5:
              chainId = _context2.sent;
              _context2.next = 8;
              return this.provider.send('eth_accounts', []);
            case 8:
              accounts = _context2.sent;
              this.update.emit({
                chainId: parseInt(chainId),
                accounts: accounts
              });
              _context2.next = 16;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](2);
              console.log(_context2.t0);
              throw new Error('Could not activate connector');
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 12]]);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
  }, {
    key: "deactivate",
    value: function () {
      var _deactivate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.provider = undefined;
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function deactivate() {
        return _deactivate.apply(this, arguments);
      }
      return deactivate;
    }()
  }]);
  return InjectedConnector;
}();